import React from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonSidebarToggle } from '../components/ButtonSidebarToggle';
import { DashboardActionbar } from '../components/DashboardActionbar';
import * as Icon from '../components/icons';

import { Container } from '../components/layout/ContainerFlex';
import { ContainerMain } from '../components/layout/ContainerMain';
import FilterPresetSelector from '../filterPreset/FilterPresetSelector';
import WarehouseContainer from '../warehouse/WarehouseContainer';
import WarehouseDashboardClients from './components/WarehouseDashboardClients';
import WarehouseDashboardCompare from './components/WarehouseDashboardCompare';
import WarehouseDashboardCompliance from './components/WarehouseDashboardCompliance';
import WarehouseDashboardCustom from './components/WarehouseDashboardCustom';
import WarehouseDashboardInsights from './components/WarehouseDashboardInsights';
import WarehouseDashboardInventory from './components/WarehouseDashboardInventory';
import WarehouseDashboardIssues from './components/WarehouseDashboardIssues';
import WarehouseDashboardLabour from './components/WarehouseDashboardLabour';
import WarehouseDashboardProcess from './components/WarehouseDashboardProcess';
import WarehouseDashboardSummary from './components/WarehouseDashboardSummary';
import WarehouseDashboardToday from './components/WarehouseDashboardToday';
import WarehouseDashboardSidebar from './sidebars/WarehouseDashboardSidebar';
import { WarehouseDashboardMenuItemId } from './store/dashboard.types';
import {
  mockFatigueMetrics,
  mockHiddenCosts,
  mockInventoryMetrics,
  mockLaborMetrics,
  mockPicklistMetrics,
  mockProcessCosts,
  mockProductivityMetrics,
  mockUOMMetrics,
} from './store/warehouseDashboard.default';

export type DashboardProps = {
  selectedMenuId?: WarehouseDashboardMenuItemId;
};

export const WarehouseDashboard: React.FC<DashboardProps> = props => {
  const { t } = useTranslation('app');
  const { selectedMenuId } = props;

  const renderDashboardContent = () => {
    switch (selectedMenuId) {
      case 'warehouse-dashboard-summary':
        return <WarehouseDashboardSummary />;
      case 'warehouse-dashboard-clients':
        return <WarehouseDashboardClients />;
      case 'warehouse-dashboard-today':
        return <WarehouseDashboardToday />;
      case 'warehouse-dashboard-insights':
        return <WarehouseDashboardInsights />;
      case 'warehouse-dashboard-process':
        return (
          <WarehouseDashboardProcess
            processCosts={mockProcessCosts}
            hiddenCosts={mockHiddenCosts}
            picklistMetrics={mockPicklistMetrics}
            timeRange={t('Last 7 Days')}
          />
        );
      case 'warehouse-dashboard-inventory':
        return (
          <WarehouseDashboardInventory
            inventoryMetrics={mockInventoryMetrics}
            uomMetrics={mockUOMMetrics}
            timeRange={t('Last 7 Days')}
          />
        );
      case 'warehouse-dashboard-labour':
        return (
          <WarehouseDashboardLabour
            laborMetrics={mockLaborMetrics}
            productivityMetrics={mockProductivityMetrics}
            fatigueMetrics={mockFatigueMetrics}
            timeRange={t('Last 7 Days')}
          />
        );
      case 'warehouse-dashboard-issues':
        return <WarehouseDashboardIssues />;
      case 'warehouse-dashboard-compliance':
        return <WarehouseDashboardCompliance />;
      case 'warehouse-dashboard-custom':
        return <WarehouseDashboardCustom />;
      case 'warehouse-dashboard-projects':
        return <WarehouseDashboardCustom />;
      case 'warehouse-dashboard-compare':
        return <WarehouseDashboardCompare />;
      default:
        return <WarehouseDashboardSummary />;
    }
  };

  return (
    <WarehouseContainer fullHeaders={true}>
      <DashboardActionbar className="bg-menu">
        <ButtonSidebarToggle
          title={t`Dashboards Menu`}
          noTitle
          icon={Icon.MenuBars3Bars}
          buttonSize={'sm'}
          sidebarID="sidebar-menu-dashboard-data"
        />
        {/* <div className={classNames('mx-2')}>{t`Warehouse Dashboard`}</div> */}
        <FilterPresetSelector />

        {/* <FeedDatePicker selectorPosition="start" /> */}
      </DashboardActionbar>
      <ContainerMain data-component="warehouse-dashboard-container">
        <WarehouseDashboardSidebar selectedId={selectedMenuId} />
        <Container col hasOverflowY>
          {renderDashboardContent()}
        </Container>
      </ContainerMain>
    </WarehouseContainer>
  );
};

export default WarehouseDashboard;
